// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastPlayer-cls1_Pu3","cls2":"PodcastPlayer-cls2_UFu PodcastPlayer-cls1_Pu3"};